/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Vlt-icon-table-full': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M22.5 0h-21C.6 0 0 .6 0 1.5v21c0 .9.6 1.5 1.5 1.5h21c.9 0 1.5-.6 1.5-1.5v-21c0-.9-.6-1.5-1.5-1.5zM21 10.5h-7.5V3H21v7.5zM10.5 3v7.5H3V3h7.5zM3 13.5h7.5V21H3v-7.5zM13.5 21v-7.5H21V21h-7.5z"/>'
  }
})
